import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventsService } from 'src/app/services/events.service';

@Component({
  standalone: false,
  selector: 'app-deactive-event-category-modal',
  templateUrl: './deactive-event-category-modal.component.html',
  styleUrls: ['./deactive-event-category-modal.component.scss'],
})
export class DeactiveEventCategoryModalComponent implements OnInit {
  @Input() id: string;
  @Input() status: string;

  finalSubmissionArray = [];

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private eventService: EventsService,
  ) {
  }

  ngOnInit(): void { }

  changeStatus() {
    this.finalSubmissionArray.push({
      eventCategoryId: this.id,
      isActive: this.status
    });
    this.eventService
      .updateStatusOfEvent(this.finalSubmissionArray[0])
      .subscribe((res) => {
        console.log(res);
        setTimeout(() => {
          this.modal.dismiss();
          window.location.reload();
        }, 1000);
      });
  }
}
